import { useState } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import {AlertDialog} from "../dialog/AlertDialog"
import classes from "./Login.module.css";
import { signIn, signIn2 } from "../../firebase/firebase";
import { useAppDispatch } from "../../app/hooks";
import { login } from "../../features/auth/authSlice";
import { getRole } from "../../services/role/roleApi";

export const Login = function Login() {
  const dispatch = useAppDispatch();
    const [user, setUser] = useState({ username: "KhiemNV", password: "19881202" });
  
    const [error, setError] = useState();
    const [modalIsOpen, setIsOpen] = useState(false);
    function openModal() {
      setIsOpen(true);
    }
    function closeModal() {
      setIsOpen(false);
    }
  
  
    const onLoginBtnClick = async () => {
      // await login3(dispatch, user);
      var res = await signIn2();
      // console.log(res);
      const newUser = res.user;
      if (newUser) {
        var {result:roleObj = {}} = await getRole(newUser.email);
        dispatch(
          login({ username: newUser.email, token: newUser.uid, roleObj })
        );
      } else {
        console.error("login fail")
      }
      // const {username:email, password} = user;
      // return signIn(user.username, user.password);
    };
  
    return (
      <div>
        {modalIsOpen && (
          <AlertDialog
            onOk={closeModal}
            title={error.title}
            message={error.message}
          ></AlertDialog>
        )}

        <div className={`${classes.content}`}>
          <div className={` ${classes.formBgr}`}>
            <Grid container justifyContent="center" spacing={3}>
              <Grid item xs={12}>
                <Grid container justifyContent="center">
                  <Typography variant="h5" component="div">
                    Đăng nhập
                  </Typography>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container justifyContent="center">
                  
                  <Button
                    data-testid="login-btn"
                    variant="contained"
                    onClick={onLoginBtnClick}
                  >
                    Sign in with Google
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    );
  };
  